
/* injects from baggage-loader */

'use strict';

import fileManagementFiltersDirective from './fileManagementFilters.directive';
import fileManagementFiltersConstant from './fileManagementFilters.constant';

/**
 * Campaign Select module definition.
 */
const fileManagementFiltersModule = angular.module('fileManagementFilters.module', []);

fileManagementFiltersModule.directive('fileManagementFilters', fileManagementFiltersDirective);
fileManagementFiltersModule.constant('fileManagementFiltersConstant', fileManagementFiltersConstant);

export default fileManagementFiltersModule;



// WEBPACK FOOTER //
// ./src/app/core/components/fileManagementFilters/fileManagementFilters.module.js